<div class="container title-container">
    <div class="row">
        <div class="col-md-12 title-inner-container">
            <h1 id="ftrpproduct{{iterationId}}" class="header-text custom-header-h2">
                {{cmsDataProductQuote.your}}
                <span style="font-weight: bold !important">{{selectedProduct}}</span> {{tileType === 'quote' ?
                cmsDataProductQuote.quote : cmsDataProductQuote.application}}
            </h1>
            <span id="padsRefNumber{{iterationId}}" class="Rectangle application-Reference">
                <i>{{tileType === 'quote' ? cmsDataProductQuote.quoteReferenceNo:
                    cmsDataProductQuote.applicationreferenceNo}}
                </i>
                <span *ngIf="SelectedProductQuoteFTRP['indicative'] == 'Y' else guaranteedQuote">
                    {{cmsDataProductQuote.indicativeText}}{{SelectedProductQuoteFTRP.quoteRefNo}}
                </span>
            </span>
            <ng-template #guaranteedQuote>
                <span>{{tileType ==='quote' ? SelectedProductQuoteFTRP.padsRefNo:
                    SelectedProductQuoteFTRP.applicationId}}</span>
            </ng-template>
        </div>
    </div>
</div>

<div class="container content-container">
    <!-- month year before tax begin -->
    <div class="row">
        <div class="col-md-12 outer-flex-container">
            <div id="paymentFreq{{iterationId}}" class="col-md-9 flex-container">
                <ng-container
                    *ngIf="SelectedProductQuoteFTRP.giaCalculated && SelectedProductQuoteFTRP.giaCalculated === 'maturityValue'">
                    <div class="row mat-flex-container">
                        <div class="text-number-bold">
                            <span id="currencyMaturity{{iterationId}}" class="text-bold-style-1">£</span>
                            <span
                                id="paymentFreqbeforeprecisionMaturity{{iterationId}}">{{getInteger(SelectedProductQuoteFTRP.annuitantMaturity)|
                                currency:'':'':'1.0-0'}}</span>
                            <span id="paymentFreqprecisionMaturity{{iterationId}}" class="text-style-2">.</span>
                            <span id="paymentFreqafterprecisionMaturity{{iterationId}}"
                                class="text-bold-style-1">{{getFraction(SelectedProductQuoteFTRP.annuitantMaturity)}}</span>
                        </div>
                        <span id="paymentFreqyearMaturity{{iterationId}}"
                            class="a-month">{{cmsDataProductQuote.maturityValue}}</span>
                    </div>

                </ng-container>

                <ng-container
                    *ngIf="SelectedProductQuoteFTRP.giaCalculated && SelectedProductQuoteFTRP.giaCalculated === 'annualIncome'">


                    <div *ngIf="SelectedProductQuoteFTRP.paymentFrequency== 'M'" class="text-number-bold"
                        style="margin-right: 11px;">
                        <span id="currencyMonth{{iterationId}}" class="text-bold-style-1">£</span>
                        <span
                            id="paymentFreqbeforeprecisionMonth{{iterationId}}">{{getInteger(SelectedProductQuoteFTRP.annuitantPension)|
                            currency:'':'':'1.0-0'}}</span>
                        <span id="paymentFreqprecisionMonth{{iterationId}}" class="text-style-2">.</span>
                        <span id="paymentFreqafterprecisionMonth{{iterationId}}"
                            class="text-bold-style-1">{{getFraction(SelectedProductQuoteFTRP.annuitantPension)}}</span>
                        <span id="paymentFreqyearMonth{{iterationId}}"
                            class="a-month">{{cmsDataProductQuote.month}}</span>
                    </div>
                    <div *ngIf="SelectedProductQuoteFTRP.paymentFrequency== 'Q'" class="text-number-bold"
                        style="margin-right: 11px;">
                        <span id="currencyQuarter{{iterationId}}" class="text-bold-style-1">£</span>
                        <span
                            id="paymentFreqbeforeprecisionQuarter{{iterationId}}">{{(getInteger(SelectedProductQuoteFTRP.annuitantYearlyPension/4))|
                            currency:'':'':'1.0-0'}}</span>
                        <span id="paymentFreqprecisionQuarter{{iterationId}}" class="text-style-2">.</span>
                        <span id="paymentFreqafterprecisionQuarter{{iterationId}}"
                            class="text-bold-style-1">{{(getFraction(SelectedProductQuoteFTRP.annuitantYearlyPension/4))}}</span>
                        <span id="paymentFreqyearQuarter{{iterationId}}"
                            class="a-month">{{contentData.currencyDurationQuarterly}}</span>
                    </div>
                    <div *ngIf="SelectedProductQuoteFTRP.paymentFrequency== 'H'" class="text-number-bold"
                        style="margin-right: 11px;">
                        <span id="currencyHalfYear{{iterationId}}" class="text-bold-style-1">£</span>
                        <span
                            id="paymentFreqbeforeprecisionHalfYear{{iterationId}}">{{(getInteger(SelectedProductQuoteFTRP.annuitantYearlyPension/2))|
                            currency:'':'':'1.0-0'}}</span>
                        <span id="paymentFreqprecisionHalfYear{{iterationId}}" class="text-style-2">.</span>
                        <span id="paymentFreqafterprecisionHalfYear{{iterationId}}"
                            class="text-bold-style-1">{{(getFraction(SelectedProductQuoteFTRP.annuitantYearlyPension/2))}}</span>
                        <span id="paymentFreqyearHalfYear{{iterationId}}"
                            class="a-month">{{contentData.currencyDurationHalfYearly}}</span>
                    </div>
                    <div *ngIf="SelectedProductQuoteFTRP.paymentFrequency== 'Y'" class="float-left text-number-bold">
                        <span id="currencyYear{{iterationId}}" class="text-bold-style-1">£</span>
                        <span
                            id="paymentFreqbeforeprecisionYear{{iterationId}}">{{getInteger(SelectedProductQuoteFTRP.annuitantYearlyPension)|
                            currency:'':'':'1.0-0'}}</span>
                        <span id="paymentFreqprecisionYear{{iterationId}}" class="text-style-2">.</span>
                        <span id="paymentFreqafterprecisionYear"
                            class="text-bold-style-1">{{getFraction(SelectedProductQuoteFTRP.annuitantYearlyPension)}}</span>
                        <span id="paymentFreqyearYear{{iterationId}}"
                            class="a-month">{{cmsDataProductQuote.year}}</span>
                    </div>

                    <div *ngIf="SelectedProductQuoteFTRP.paymentFrequency!== 'Y'" class="text-number-style">
                        <span id="currencyYear{{iterationId}}" class="text-style-1">£</span>
                        <span id="annuitantYearlyPensionBeforePrecision{{iterationId}}"
                            class="number-style-2">{{getInteger(SelectedProductQuoteFTRP.annuitantYearlyPension)|
                            currency:'':'':'1.0-0'}}{{contentData.currencyPoint}}</span>
                        <span id="annuitantYearlyPensionAfterPrecision{{iterationId}}"
                            class="text-style-1">{{getFraction(SelectedProductQuoteFTRP.annuitantYearlyPension)}}</span>
                        <span id="paymentFreqyearYear{{iterationId}}" class="a-year">{{cmsDataProductQuote.year}}</span>
                        <span id="beforeTax{{iterationId}}" class="a-year">{{contentData.beforeTax}}</span>
                    </div>



                </ng-container>
                <!-- <span id="beforeTax{{iterationId}}" class="a-year">{{contentData.beforeTax}}</span> -->
            </div>

            <div *ngIf="isValidCard && tileType !== 'application'" class="col-md-3 quote-expiry-col">
                <div class="left-align" style="margin-top: 24px;">
                    <span id="expiryInText{{iterationId}}"
                        class="quote-expiry">{{cmsDataProductQuote.expiryInText}}</span>
                </div>
                <div>
                    <div class="center-align">
                        <div id="expiredinDays{{iterationId}}" class="quote-expiry-days-tooltip">
                            <div class="quoteExpiry-count">
                                <span id="expiresNumber"
                                    class="text-number-days-number">{{SelectedProductQuoteFTRP.quoteExpiry}}</span>
                                <span id="expiresDays" class="text-number-days">{{cmsDataProductQuote.expiryIn}}</span>
                            </div>
                            <div class="quoteExpiry-tooltip">
                                <app-tool-tip-notification [childId]="'quoteExpiry'"
                                    [tooltipName]="'quoteExpiry_tooltip'"
                                    *ngIf="cmsDataProductQuote.expiryNotification.infoIconFlag"
                                    class="col-sm-1 padding-for-toolTip"
                                    [tooltipData]="cmsDataProductQuote.expiryNotification.infoIconData"
                                    (onDisplayFtrpMobileTooltipEmitter)="ftrpQuoteReceiver()"></app-tool-tip-notification>
                            </div>
                            <app-modal *ngIf="displayFtrpTooltipAlert" [modalConfig]="tooltipModalConfig"
                                (closeModal)="closeModal()" (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)"
                                (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- month year before tax end -->

    <div class="row">
        <div class="col-md-12 border"></div>
    </div>

    <div class="row">
        <div class=" flex-vertical-1 col-md-3">
            <span aria-level="2" id="pensionPotText{{iterationId}}"
                class="product-option">{{contentData.pensionPotInfo}}</span>

            <div id="pensionPotValue{{iterationId}}" class="text-number-style">
                <span id="pensionPotCurrType{{iterationId}}" class="text-style-1">{{contentData.currencyType}}</span>
                <span id="pensionPotPensFundBeforeDot{{iterationId}}"
                    class="number-style-2">{{getInteger(SelectedProductQuoteFTRP.pensionFund)|
                    currency:'':'':'1.0-0'}}{{contentData.currencyPoint}}</span>
                <span id="pensionPotPensFundAfterDot{{iterationId}}"
                    class="text-style-1">{{getFraction(SelectedProductQuoteFTRP.pensionFund)}}</span>
            </div>
        </div>
        <div class=" flex-vertical-2 col-md-3">
            <span aria-level="2" id="startDateText{{iterationId}}"
                class="product-option">{{contentData.startDateInfo}}</span>
            <span id="startDateValue{{iterationId}}"
                class="text-number-style">{{SelectedProductQuoteFTRP.startDate}}</span>
        </div>
        <div class=" flex-vertical-3 col-md-3">
            <span aria-level="2" id="termText{{iterationId}}" class="product-option">{{contentData.termInfo}}</span>
            <span id="termValue{{iterationId}}" class="income-style">{{getTerm()}}</span>
        </div>
        <div class=" flex-vertical-4 col-md-3">
            <span aria-level="2" id="incomeInfoText{{iterationId}}"
                class="product-option">{{contentData.incomeInfo}}</span>
            <div *ngIf="getIncome()" id="incomeIncreaseValue{{iterationId}}" class="income-style">
                <span id="incomeValue{{iterationId}}" class="income-style">{{SelectedProductQuoteFTRP.income}}</span>
            </div>
            <div *ngIf="getNotSelectedIncome()" id="incomeIncreaseText{{iterationId}}">
                <span id="incomeNotSelected{{iterationId}}" class="income-style">{{contentData.notSelected}}</span>
            </div>
        </div>
    </div>

    <div class="row container-margin-top">
        <div class=" flex-vertical-1 col-md-3">
            <span aria-level="2" id="taxFreeLumpSumText"
                class="product-option">{{contentData.taxFreeLumpSumInfo}}</span>

            <div *ngIf="+SelectedProductQuoteFTRP.totalTaxFreeCashAmount > 0 ;else displayNotProvidedTax"
                id="taxFreeLumpSumTValue{{iterationId}}" class="text-number-style">
                <span id="taxFreeLumpSumCurrencyType" class="text-style-1">{{contentData.currencyType}}</span>
                <span id="taxFreeLumpSumCurrency"
                    class="number-style-2">{{getInteger(SelectedProductQuoteFTRP.totalTaxFreeCashAmount)|
                    currency:'':'':'1.0-0'}}{{contentData.currencyPoint}}</span>
                <span id="taxFreeLumpSumvalue{{iterationId}}"
                    class="text-style-1">{{getFraction(SelectedProductQuoteFTRP.totalTaxFreeCashAmount)}}</span>
            </div>
            <div>
                <ng-template id="taxFreeLumpSumText" #displayNotProvidedTax>
                    <span id="taxFreeLumpSumTValue{{iterationId}}"
                        class="income-style">{{contentData.notSelected}}</span>
                </ng-template>
            </div>
        </div>

        <div class=" flex-vertical-2 col-md-3">
            <ng-container
                *ngIf="SelectedProductQuoteFTRP.giaCalculated && (SelectedProductQuoteFTRP.giaCalculated === 'annuitantYearlyPension' || SelectedProductQuoteFTRP.giaCalculated === 'annualIncome')">
                <span aria-level="2" id="maturityValueText" class="product-option">{{contentData.maturityValue}}</span>
                <div class="text-number-style">
                    <span id="maturityValueCurrencyType" class="text-style-1">{{contentData.currencyType}}</span>
                    <span id="maturityValueSumCurrency"
                        class="number-style-2">{{getInteger(SelectedProductQuoteFTRP.maturityAmount)|
                        currency:'':'':'1.0-0'}}{{contentData.currencyPoint}}</span>
                    <span id="maturityValueSumvalue{{iterationId}}"
                        class="text-style-1">{{getFraction(SelectedProductQuoteFTRP.maturityAmount)}}</span>
                </div>
            </ng-container>
            <ng-container
                *ngIf="SelectedProductQuoteFTRP.giaCalculated && SelectedProductQuoteFTRP.giaCalculated === 'maturityValue'">
                <span aria-level="2" id="yearlyIncomeText" class="product-option">{{contentData.yearlyIncome}}</span>
                <div class="text-number-style">
                    <ng-container *ngIf="SelectedProductQuoteFTRP && SelectedProductQuoteFTRP.annuitantYearlyPension &&
                                            SelectedProductQuoteFTRP.annuitantYearlyPension > 0">
                        <span id="yearlyIncomeCurrencyType" class="text-style-1">{{contentData.currencyType}}</span>
                        <span id="yearlyIncomeCurrency"
                            class="number-style-2">{{getInteger(SelectedProductQuoteFTRP.annuitantYearlyPension)|
                            currency:'':'':'1.0-0'}}{{contentData.currencyPoint}}</span>
                        <span id="yearlyIncomevalue{{iterationId}}"
                            class="text-style-1">{{getFraction(SelectedProductQuoteFTRP.annuitantYearlyPension)}}</span>
                    </ng-container>
                    <ng-container *ngIf="getNone()">

                        <span id="yearlyIncomeCurrency" class="text-style-1">{{contentData.none}}</span>

                    </ng-container>
                </div>
            </ng-container>
        </div>

        <div class=" flex-vertical-3 col-md-3">
            <span aria-level="2" id="guaranteedPaymentText-info"
                class="product-option">{{contentData.guaranteedPaymentInfo}}</span>
            <div *ngIf="SelectedProductQuoteFTRP.guaranteedTerm > 0 ;else displayNotProvidedGuaranteedPayment">
                <span id="guaranteedPaymentValue{{iterationId}}"
                    class="income-style">{{SelectedProductQuoteFTRP.guaranteedTermIndicator === 'N' ? 'None' :
                    (SelectedProductQuoteFTRP.guaranteedTermIndicator === 'F' ? 'Whole term' :
                    SelectedProductQuoteFTRP.guarantedPaymentPeriod) }}</span>
            </div>
            <div>
                <ng-template id="guaranteedPaymentText" #displayNotProvidedGuaranteedPayment>
                    <span id="guaranteedPaymentValue{{iterationId}}"
                        class="income-style">{{contentData.notSelected}}</span>
                </ng-template>
            </div>
        </div>

        <div class=" flex-vertical-3 col-md-3">
            <span aria-level="2" id="incomeIncreaseText-info"
                class="product-option">{{contentData.incomeIncreaseInfo}}</span>
            <span id="incomeIncreaseValue{{iterationId}}"
                class="income-style">{{SelectedProductQuoteFTRP.incomeIncrease}}</span>
        </div>
    </div>

    <div *ngIf="isDocumentRequired" class="row container-margin-top">
        <div class="col-md-3">
            <div class="container Container">
                <div class="row row-position">

                    <div class="col-md-8 col-position1">
                        <div class="row Key-Features">
                            <span role="heading" aria-level="3">{{cmsData1.keyFeature1}}</span>
                        </div>
                        <div class="row pdf-size1">
                            <span>{{this.getYourPersonalisedQuoteSize()}}</span>
                        </div>
                    </div>

                    <div class="col-md-4 col-position2">
                        <a>
                            <div *ngIf="loadingPDFFlag" class="spinner spinner-white custom-spinner">
                                <div class="spinner-ring" aria-hidden="true"></div>
                                <span class="access">Loading...</span>
                            </div>
                            <img *ngIf="!loadingPDFFlag" id="personalisedQuotePdf" src="assets/images/guide.svg"
                                alt="Personalised Quote PDF" class="Guide reflect" (click)="handlePDFDetails(1)"
                                tabindex="0" (keyup.enter)="handlePDFDetails(1)">
                        </a>
                    </div>


                </div>
            </div>
        </div>

        <div class="col-md-3">
            <div class="container Container">
                <div class="row row-position">

                    <div class="col-md-8 col-position1">
                        <div class="row Key-Features">
                            <span role="heading" aria-level="3">{{cmsData1.keyFeature2}}</span>
                        </div>
                        <div class="row PDF-XXXMB2">
                            <span>{{this.keyFeatureSize}}</span>
                        </div>
                    </div>

                    <div class="col-md-4 col-position2 padding-left-6">
                        <a>
                            <img id="keyFeaturePdf" tabindex="0" (keyup.enter)="handlePDFDetails(2)"
                                alt="key feature PDF" src="assets/images/guide.png" srcset="assets/images/guide@2x.png 2x,
                                assets/images/guide@3x.png 3x" class="Guide reflect" (click)="handlePDFDetails(2)">
                        </a>
                    </div>

                </div>
            </div>
        </div>

        <div class="col-md-3">
            <div class="container Container">
                <div class="row row-position">

                    <div class="col-md-8 col-position1">
                        <div class="row Key-Features">
                            <span role="heading" aria-level="3">{{cmsData1.keyFeature3}}</span>
                        </div>
                        <div class="row PDF-XXXMB3">
                            <span>{{this.termsAndConditionsSize}}</span>
                        </div>
                    </div>

                    <div class="col-md-4 col-position2 padding-left-2">
                        <a>
                            <img id="termsAndConditionPdf" tabindex="0" (keyup.enter)="handlePDFDetails(3)"
                                alt="terms and condition PDF" src="assets/images/guide.png" srcset="assets/images/guide@2x.png 2x,
                                assets/images/guide@3x.png 3x" class="Guide reflect" (click)="handlePDFDetails(3)">
                        </a>
                    </div>

                </div>
            </div>
        </div>

        <div class="col-md-3">
            <div class="container Container">
                <div class="row row-position">

                    <div class="col-md-8 col-position1">
                        <div class="row Key-Features">
                            <span role="heading" aria-level="3">{{cmsData1.keyFeature4}}</span>
                        </div>
                        <div class="row PDF-XXXMB4">
                            <span>{{this.getPensionScamSize()}}</span>
                        </div>
                    </div>
                    <div class="col-md-4 col-position2">
                        <a>
                            <img id="PensionScamPdf" tabindex="0" (keyup.enter)="handlePDFDetails(4)"
                                src="assets/images/guide.png" alt="Pension Scam PDF" srcset="assets/images/guide@2x.png 2x,
                                assets/images/guide@3x.png 3x" class="Guide reflect" (click)="handlePDFDetails(4)">
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>